import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withDefaults } from '../../../utils/withDefaults';
const TextRoot = styled(Typography)(({
  theme
}) => ({
  marginBottom: theme.spacing(2)
}));
export const Text = withDefaults(TextRoot, {
  variant: 'Lato Body 2'
});